import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheckIcon, FileTextIcon, PackageIcon, CalculatorIcon, ReceiptIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <ShieldCheckIcon className="w-6 h-6 text-copper" data-id="element-206" />,
    title: 'The 72-Hour Lockdown Checklist',
    description: 'Exactly how to secure the property and utilities to prevent a $10,000 "vacancy" catastrophe.'
  }, {
    icon: <FileTextIcon className="w-6 h-6 text-copper" data-id="element-207" />,
    title: 'The Successor-in-Interest Script',
    description: 'The exact words to say to the bank to trigger federal protection and stop the foreclosure clock.'
  }, {
    icon: <PackageIcon className="w-6 h-6 text-copper" data-id="element-208" />,
    title: 'The "Three Pile" System',
    description: 'How to empty 40 years of clutter in 48 hours without losing your mind or your sentimental treasures.'
  }, {
    icon: <CalculatorIcon className="w-6 h-6 text-copper" data-id="element-209" />,
    title: 'The Equity Audit Worksheet',
    description: 'A cold-blooded calculator to help you decide if you should Sell, Rent, or literally just walk away.'
  }, {
    icon: <ReceiptIcon className="w-6 h-6 text-copper" data-id="element-210" />,
    title: 'The Step-Up in Basis Guide',
    description: 'How to avoid a massive (and unnecessary) $80,000 tax bill from the IRS.'
  }];
  return <section className="bg-cream py-24 px-4" data-id="element-211">
      <div className="max-w-4xl mx-auto" data-id="element-212">
        <FadeIn className="text-center mb-16" data-id="element-213">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-4" data-id="element-214">
            What's Inside the Kit
          </h2>
          <div className="w-24 h-px bg-copper mx-auto" data-id="element-215" />
        </FadeIn>

        <div className="space-y-6" data-id="element-216">
          {items.map((item, index) => <FadeIn key={index} delay={0.1 * index} direction="up" className="bg-white p-6 md:p-8 border border-cream-dark shadow-sm flex flex-col md:flex-row gap-6 items-start md:items-center hover:shadow-md transition-shadow duration-300" data-id="element-217">
              <div className="flex-shrink-0 w-12 h-12 bg-cream flex items-center justify-center rounded-full border border-copper/20" data-id="element-218">
                {item.icon}
              </div>
              <div data-id="element-219">
                <h3 className="text-xl font-heading font-bold text-navy mb-2" data-id="element-220">
                  {item.title}
                </h3>
                <p className="text-text-dark/80 font-body leading-relaxed" data-id="element-221">
                  {item.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}